import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Filter,
  ReferenceInput,
  SelectInput
} from "react-admin";

const DistrictFilter = (props) => {
  return (
    <Filter {...props}>
      <ReferenceInput
        label="Season"
        source="seasonCode"
        reference="availableSeasons"
        alwaysOn
      >
        <SelectInput optionText="label" optionValue="code" />
      </ReferenceInput>
      <ReferenceInput
        label="Sport"
        source="sportCode"
        reference="sportCodes"
        alwaysOn
      >
        <SelectInput optionText="label" optionValue="code" />
      </ReferenceInput>
    </Filter>
  );
};

const DistrictList = (props) => (
  <List {...props} bulkActionButtons={false} filters={<DistrictFilter />}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="seasonCode" />
      <TextField source="leagueCode" />
      <TextField source="sportCode" />
      <TextField source="conferenceCode" />
      <TextField source="divisionCode" />
      <TextField source="regionCode" />
      <TextField source="districtCode" />
      <TextField source="label" />
    </Datagrid>
  </List>
);

export default DistrictList;
